import { Phone } from "lucide-react";

/**
 * Bouton flottant "Appeler GMC" — visible uniquement sur mobile/tablette.
 * Positionné en bas à gauche pour ne pas chevaucher le ChatBot (bas-droite).
 * Couleur verte pour signaler "communication / appel" — contraste avec
 * l'orange brand sans dénaturer la palette.
 */
export default function FloatingCallButton() {
  return (
    <a
      href="tel:+33763433867"
      data-testid="floating-call-btn"
      aria-label="Appeler GMC Rénovation Façade au 07 63 43 38 67"
      className="fixed bottom-5 left-5 z-50 md:hidden flex items-center gap-2 pl-4 pr-5 py-3.5 rounded-full bg-[#16A34A] text-white shadow-2xl shadow-[#16A34A]/40 hover:bg-[#15803D] active:scale-95 transition-all"
    >
      <span className="relative flex h-9 w-9 items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-white/40 animate-ping" />
        <span className="relative inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/15">
          <Phone size={16} className="text-white" />
        </span>
      </span>
      <span className="text-sm font-semibold tracking-wide">Appeler GMC</span>
    </a>
  );
}
